<template>
  <div class="bg-[rgb(15,23,42)] py-3 sticky top-0 z-50 text-black">
    <div class="container mx-auto max-w-[1200px] px-4">
      <div class="flex items-center justify-between">
        <router-link
          :to="{ name: 'HodHome' }"
          class="brand w-nav-brand w--current flex items-center"
        >
          <img
            :src="logo_image"
            alt="Logo"
            class="w-20 sm:w-24 md:w-32 lg:w-36 xl:w-40 py-4 object-contain"
          />
        </router-link>

        <!-- Desktop Menu -->
        <div class="flex items-center gap-8">
          <div
            class="text-[#0085DB] px-5 font-bold hidden md:block"
            v-if="this.userInfo"
          >
            {{
              this.userInfo.user.permission.charAt(0).toUpperCase() +
              this.userInfo.user.permission.slice(1)
            }}
          </div>
          <div class="hidden md:flex items-center gap-5">
            <div class="flex items-center gap-10">
              <div class="relative cursor-pointer dropdown-container">
                  <div
                  class="menu-trigger group relative flex cursor-pointer items-center gap-2 rounded-full px-4 py-2 backdrop-blur-sm transition-all duration-300 hover:bg-white/10 hover:shadow-lg active:scale-95"
                  @click="MenuToggle('menu')"
                  :class="
                    toggleMenuName === 'menu' ? 'bg-white/10 shadow-lg' : ''
                  "
                >
                  <p class="text-sm font-semibold text-white tracking-wide">
                    Menu
                  </p>

                  <svg
                    class="h-3 w-3 text-white transition-transform duration-300"
                    :class="toggleMenuName === 'menu' ? 'rotate-180' : ''"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>

                <div
                  class="absolute right-0 top-12 z-50 bg-white rounded-2xl shadow-lg"
                  style="width: 180px"
                  v-if="toggleMenuName == 'menu'"
                >
                  <!-- <router-link
                    :to="{ name: 'HodDashboards' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-t-2xl"
                    :class="{
                      'text-[#0085db]': $route.name === 'HodDashboards',
                      'text-black': $route.name !== 'HodDashboards',
                    }"
                  >
                    Dashboard</router-link
                  >
                  <hr /> -->
                  <router-link
                    :to="{ name: 'AdminCoursess' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-t-2xl"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminCoursess',
                      'text-black': $route.name !== 'AdminCoursess',
                    }"
                  >
                    All Courses</router-link
                  >
                  <hr />

                  <router-link
                    :to="{ name: 'AdminNewCourses' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'AdminNewCourses',
                      'text-black': $route.name !== 'AdminNewCourses',
                    }"
                  >
                    Add New Course</router-link
                  >
                  <hr />

                  <router-link
                    :to="{ name: 'HodBatches' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'HodBatches',
                      'text-black': $route.name !== 'HodBatches',
                    }"
                  >
                    Batches</router-link
                  >
                  <hr />

                  <router-link
                    :to="{ name: 'HodCounts' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'HodCounts',
                      'text-black': $route.name !== 'HodCounts',
                    }"
                  >
                    Staff Counts</router-link
                  >
                  <hr />
                  <!-- <router-link
                    :to="{ name: 'InstructorBlogsView' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'InstructorBlogsView',
                      'text-black': $route.name !== 'InstructorBlogsView',
                    }"
                  >
                    New Blog</router-link
                  >

                  <hr /> -->

                  <router-link
                    :to="{ name: 'InstructorBlogsList' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                    :class="{
                      'text-[#0085db]': $route.name === 'InstructorBlogsList',
                      'text-black': $route.name !== 'InstructorBlogsList',
                    }"
                  >
                    Blogs</router-link
                  >

                  <hr />
                  <router-link
                    :to="{ name: 'DownloadHistory' }"
                    class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hover:rounded-b-2xl"
                    :class="{
                      'text-[#0085db]': $route.name === 'DownloadHistory',
                      'text-black': $route.name !== 'DownloadHistory',
                    }"
                  >
                    Download History</router-link
                  >

                  <hr />
                </div>
              </div>
            </div>
          </div>

          <!-- Message -->

          <div class="relative dropdown-container">
            <div class="relative  p-1 rounded-md hover:bg-white/20"
             :class=" toggleMenuName === 'messages' || $route.name === 'StudentMessagesList' ? 'bg-white/20' : ''" @click="MenuToggle('messages')">
              <p
                class="bg-white flex items-center justify-center text-primary !w-[25px] !h-[25px] text-xs rounded-full absolute -top-6 -right-5"
              >
                {{ messageCount || 0 }}
              </p>

              <img
                src="@/assets/new/chat.svg"
                width="20"
                height="20"
                class="cursor-pointer"
              />
            </div>
            <div
              v-if="toggleMenuName == 'messages'"
              class="absolute right-[-120px] lg:right-0 top-14 lg:top-10 w-64 z-10 bg-white rounded-2xl shadow-lg p-4"
            >
              <div class="font-bold text-sm pb-3 flex items-center gap-2">
                Messages
                <p
                  class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
                  v-if="messageCount != 0"
                >
                  {{ messageCount }}
                </p>
              </div>

              <div class="flex flex-col gap-2">
                <div v-if="messageList.length != 0" class="flex flex-col gap-2">
                  <router-link
                    :to="{ name: 'StudentMessagesList' }"
                    class="flex flex-col border gap-1 py-2 px-4 rounded-lg hover:bg-gray-100"
                    :class="{
                      'bg-white border-blue-500 shadow-md ring-1 ring-blue-100 hover:bg-blue-50':
                        !message.readed,
                      'bg-white border-gray-300 hover:bg-gray-100 hover:border-gray-300':
                        message.readed,
                    }"
                    v-for="(message, index) in messageList.slice(0, 3)"
                    :key="message.id || index"
                  >
                    <h4
                      class="text-xs truncate transition-colors uppercase font-bold"
                      :class="
                        !message.readed
                          ? 'font-bold text-slate-900'
                          : 'font-medium text-slate-600'
                      "
                    >
                      {{ message.owner_display_name || "NA" }}
                    </h4>
                    <div
                      class="text-[12px] tracking-tight flex w-full"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      <p class="line-clamp-1 w-full">
                        {{ message.course_title || "NA" }}
                      </p>
                    </div>
                    <p
                      class="text-xs line-clamp-1"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      {{ message.text || "No preview available..." }}
                    </p>
                    <p
                      class="text-xs"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      {{ formatDateTime(message.created_at) }}
                    </p>
                  </router-link>

                  <router-link
                    :to="{ name: 'StudentMessagesList' }"
                    v-if="messageList.length > 3"
                    class="text-blue-600 hover:text-blue-700 font-bold text-xs py-2 text-end"
                  >
                    See More
                  </router-link>
                </div>
                <router-link
                  :to="{ name: 'StudentMessagesList' }"
                  v-if="this.messageList.length == 0"
                  class="flex text-sm flex-col border gap-1 py-2 px-4 rounded-lg"
                  >No Data Found</router-link
                >
              </div>
            </div>
          </div>

          <!-- Notifications -->
          <div class="mr-10 relative dropdown-container">
            <div class="relative" @click="MenuToggle('notification')">
              <p
                class="bg-white flex items-center justify-center text-primary !w-[25px] !h-[25px] text-xs rounded-full absolute -top-5 -right-5"
              >
                {{ notificationData?.unread_count || "-" }}
              </p>

              <img
                src="@/assets/notification.png"
                width="24"
                height="24"
                class="cursor-pointer"
              />
            </div>

            <div
              class="absolute right-[-70px] lg:right-0 top-14 lg:top-10 w-64 z-10 bg-white rounded-2xl shadow-lg p-4"
              v-if="toggleMenuName === 'notification'"
              style="width: 250px"
            >
              <div
                class="font-bold text-sm pb-3 flex items-center gap-2 text-black"
              >
                Notifications

                <p
                  v-if="notificationData?.unread_count > 0"
                  class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
                >
                  {{ notificationData.unread_count }}
                </p>
              </div>

              <div class="flex flex-col gap-2">
                <div
                  v-if="notificationData?.data?.length > 0"
                  class="flex flex-col gap-2"
                >
                  <router-link
                    v-for="notifi in notificationData.data.slice(0, 3)"
                    :key="notifi.id"
                    :to="{ name: 'StudentNotifications' }"
                    class="flex flex-col border gap-1 py-2 px-4 rounded-lg hover:bg-slate-100"
                    :class="
                      !notifi.read
                        ? 'bg-white border-blue-400 shadow-sm ring-1 ring-blue-50 hover:bg-blue-50'
                        : 'bg-slate-50 border-slate-200 opacity-80 hover:opacity-100 hover:bg-white hover:border-slate-300'
                    "
                  >
                    <div class="flex justify-between items-start">
                      <p
                        class="font-bold text-xs truncate"
                        :class="
                          !notifi.read ? 'text-gray-900' : 'text-gray-500'
                        "
                      >
                        {{ notifi.topic }}
                      </p>

                      <span
                        v-if="!notifi.read"
                        class="flex h-2 w-2 rounded-full bg-blue-500"
                      ></span>
                    </div>

                    <p class="text-[10px] text-gray-400">
                      {{ formatDate(notifi.created_at) }}
                    </p>
                  </router-link>

                  <router-link
                    v-if="notificationData.data.length > 3"
                    :to="{ name: 'StudentNotifications' }"
                    class="text-blue-600 hover:text-blue-800 hover:underline font-bold text-xs py-2 text-center transition-all"
                  >
                    See More
                  </router-link>
                </div>

                <router-link
                  v-else
                  :to="{ name: 'StudentNotifications' }"
                  class="flex text-xs flex-col border gap-1 py-2 px-4 rounded-lg text-black"
                >
                  No Data Found
                </router-link>
              </div>
            </div>
          </div>
          <!-- Profile Dropdown -->
          <div class="relative z-50 dropdown-container">
            <div
              @click="MenuToggle('profile')"
              class="flex items-center cursor-pointer"
            >
              <!-- {{ userInfo.image }}  -->
              <img
                v-if="userInfo && userInfo.image && userInfo.image != null"
                :src="userInfo.image"
                 :class="[
                  'w-10 h-10 rounded-full border-2 transition-all duration-200',
                  toggleMenuName === 'profile' || $route.name === 'HodProfile'
                    ? 'border-blues'
                    : 'border-white hover:border-blue-600',
                ]"
              />
              <img
                v-else
                src="@/assets/new/image.png"
                 :class="[
                  'w-10 h-10 rounded-full border-2 transition-all duration-200',
                  toggleMenuName === 'profile' || $route.name === 'HodProfile'
                    ? 'border-blues'
                    : 'border-white hover:border-blue-600',
                ]"
              />

              <!-- <img
                v-if="isAuthenticated && profileInfo != null && profileInfo.data.profile"
                :src="profileInfo.data.profile"
                class="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                v-else
                src="@/assets/new/image.png"
                class="w-10 h-10 rounded-full border-2 border-white"
              /> -->
            </div>

            <!-- <div            
              @click="MenuToggle('profile')"
              class="flex items-center cursor-pointer"
            >
              <img
                v-if="isAuthenticated && profileInfo != null && profileInfo.data.profile"
                :src="profileInfo.data.profile"
                class="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                v-else
                src="@/assets/newd/Group 151.png"
                class="w-10 h-10 rounded-full border-2 border-white"
              />
            </div> -->

            <div
              v-if="toggleMenuName == 'profile'"
              class="absolute right-0 mt-2 w-48 bg-white rounded-2xl shadow-lg"
            >
              <router-link
                :to="{ name: 'HodProfile' }"
                class="flex items-center gap-2 py-3 px-4 text-xs cursor-pointer hover:bg-slate-200 hover:rounded-t-2xl"
              >
                <img
                  src="@/assets/new/profile.png"
                  class="w-5 h-5"
                  alt="Profile"
                />
                <div>
                  <span
                    class="font-semibold"
                    :class="{
                      'text-[#0085db]': $route.name === 'HodProfile',
                      'text-gray-800': $route.name !== 'HodProfile',
                    }"
                    >Profile</span
                  >
                  <!-- <span>62135458</span>
                  <span>Compt Science</span> -->
                </div>
              </router-link>
              <hr />

              <router-link
                v-if="checkinTheList('Timetable')"
                :to="{ name: 'HodTimeTable' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'HodTimeTable',
                  'text-gray-800': $route.name !== 'HodTimeTable',
                }"
              >
                Time Table</router-link
              >
              <!-- <hr v-if="checkinTheList('Timetable')" /> -->
              <router-link
                v-if="checkinTheList('Attendance')"
                :to="{ name: 'HodAttendance' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'HodAttendance',
                  'text-gray-800': $route.name !== 'HodAttendance',
                }"
              >
                Attendance</router-link
              >
              <!-- <hr v-if="checkinTheList('Attendance')" /> -->

              <router-link
                :to="{ name: 'HodMyTask' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'HodMyTask',
                  'text-gray-800': $route.name !== 'HodMyTask',
                }"
              >
                My Task</router-link
              >
              <hr />

              <router-link
                :to="{ name: 'HodSyallbusView' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'HodSyallbusView',
                  'text-gray-800': $route.name !== 'HodSyallbusView',
                }"
              >
                User Instructions</router-link
              >
              <hr />
              <!-- <router-link
                :to="{ name: 'StroageFilesView' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'StroageFilesView',
                  'text-black': $route.name !== 'StroageFilesView',
                }"
              >
                My Drive
              </router-link>
              <hr /> -->

              <!-- <a href="https://coms.cambridge.edu.in/" class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer" target="blank"> Support</a>
              <hr /> -->

              <div
                @click="
                  LogOutModal = true;
                  toggleMenuName = '';
                "
                class="flex items-center gap-2 py-3 px-4 cursor-pointer text-red-500 font-semibold text-xs hover:bg-slate-200 hover:rounded-b-2xl"
              >
                <img src="@/assets/new/logout.png" width="15" height="15" />
                Logout
              </div>
            </div>
          </div>
        </div>
        <div class="lg:hidden md:hidden relative dropdown-container">
          <button
            @click="MenuToggle('mobile_menu')"
            class="text-white focus:outline-none"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
          <div
            v-if="toggleMenuName == 'mobile_menu'"
            class="absolute right-6 top-20 z-50 bg-white rounded-2xl shadow-lg lg:hidden"
            style="width: 180px"
          >
            <router-link
              :to="{ name: 'HodDashboards' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'HodDashboards',
                'text-black': $route.name !== 'HodDashboards',
              }"
            >
              Dashboard</router-link
            >
            <hr />
            <router-link
              :to="{ name: 'AdminCoursess' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'AdminCoursess',
                'text-black': $route.name !== 'AdminCoursess',
              }"
            >
              All Courses</router-link
            >
            <hr />

            <router-link
              :to="{ name: 'AdminNewCourses' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'AdminNewCourses',
                'text-black': $route.name !== 'AdminNewCourses',
              }"
            >
              Add New Course</router-link
            >
            <hr />

            <router-link
              :to="{ name: 'HodBatches' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'HodBatches',
                'text-black': $route.name !== 'HodBatches',
              }"
            >
              Courses</router-link
            >
            <hr />

            <router-link
              :to="{ name: 'HodCounts' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'HodCounts',
                'text-black': $route.name !== 'HodCounts',
              }"
            >
              Staff Counts</router-link
            >
            <hr />
            <router-link
              :to="{ name: 'InstructorBlogsView' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'InstructorBlogsView',
                'text-black': $route.name !== 'InstructorBlogsView',
              }"
            >
              New Blog</router-link
            >

            <hr />

            <router-link
              :to="{ name: 'InstructorBlogsList' }"
              class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
              :class="{
                'text-[#0085db]': $route.name === 'InstructorBlogsList',
                'text-black': $route.name !== 'InstructorBlogsList',
              }"
            >
              Blogs</router-link
            >

            <hr />
          </div>
        </div>
      </div>
    </div>

    <Logout
      v-if="LogOutModal"
      @logOut="logOut"
      @cancel="LogOutModal = !LogOutModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import axios from "axios";
import Logout from "@/components/Logout.vue";

export default {
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "userInfo",
      "notificationCount",
      "permissionList",
      "messageCount",
      "notificationData",
    ]),
  },

  data() {
    return {
      logo_image: require(`${process.env.VUE_APP_COMS_LOGO}`),
      toggleMenuName: null,
      profileInfo: null,
      LogOutModal: false,
      notificationList: [],
      messageList: [],
      // messagecount:null,
    };
  },

  components: {
    Logout,
  },

  created() {
    this.getNotifications();
    //  this.getMessages();

    if (this.userInfo) {
      let token = this.userInfo.token_key;
      let slug_id = this.userInfo.slug_id;
      axios
        .get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${token}&format=json`,
        )
        .then((response) => (this.profileInfo = response.data));
    } else {
      console.log("Not Login");
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.$store.dispatch("connectMessageSocket");

    this.$store.commit("SET_ON_NEW_MESSAGE", () => {
      this.loadMessages(this.currentPage);
    });

    this.loadMessages();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    ...mapActions(["logOutUser"]),
    ...mapMutations(["notifyCount"]),
    async loadMessages(page = 1) {
      if (!this.userInfo) return;

      const data = await this.$store.dispatch("fetchMessageList", {
        userId: this.userInfo.user.id,
        token: this.userInfo.token_key,
        page,
      });

      this.messageList = data.data; // message array
    },
     formatDateTime(dateString) {
      const date = new Date(dateString);
      const now = new Date();

      const isSameDate =
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

      if (isSameDate) {
        // Show only time if today
        return date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      } else {
        // Show full date and time if not today
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      }
    },
     formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "numeric",
        year: "numeric",
      });
    },
    checkinTheList(feature) {
      // let bool = false;
      let check = this.permissionList.find((x) => x === feature);
      if (check != undefined) {
        return true;
      } else {
        return false;
      }
    },

    async getNotifications() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
          }
        });
    },

    MenuToggle(name) {
      if (this.toggleMenuName == name) {
        this.toggleMenuName = null;
      } else {
        this.toggleMenuName = name;
      }
    },

    async logOut() {
      await this.logOutUser();
      this.LogOutModal = false;
      this.$router.push({
        name: "Login",
      });
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.toggleMenuName = null;
      }
    },
    async getMessages() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/message-course-overall-details/?client__id=${this.userInfo.user.id}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            this.messageList = response.data.data.data;
            this.messagecount = response.data.count;
          }
        });
    },
  },
};
</script>

<style></style>
